import {
  ActivatedRouteSnapshot,
  CanActivate,
  GuardResult,
  MaybeAsync,
  RouterStateSnapshot,
} from '@angular/router';
import { inject, Injectable } from '@angular/core';
import { catchError, switchMap, of, timeout } from 'rxjs';
import { AuthService } from '../services/auth.service';
import { environments } from '../../environments/env.production';
import { PermissionService } from '../services/permission.service';

@Injectable({ providedIn: 'root' })
export class AuthGuard implements CanActivate {
  private authService = inject(AuthService);
  private permissionService = inject(PermissionService);

  canActivate(
    _: ActivatedRouteSnapshot,
    __: RouterStateSnapshot,
  ): MaybeAsync<GuardResult> {
    const loginPortal = environments.loginPortalUrl;

    // return true;

    return this.authService.validateSessionExist().pipe(
      switchMap((response: any) => {
        this.authService.setLoggedInStatus(response.body);

        if (this.authService.getLoggedInStatus() === 'MFA NOT VERIFIED') {
          window.location.href = loginPortal + 'mfa';
          return of(false);
        }

        if (this.authService.getLoggedInStatus() === 'AUTHORIZED_USER') {
          if (sessionStorage.getItem('accessToken')) {
            this.authService.setAuthLibAttributes();
            this.permissionService.fetchPermission();
            this.authService.fetchClientsAssociatedWithUser();
            return of(true);
          }

          return this.authService.getDatafromStorage().pipe(
            timeout(3000),
            switchMap((responseData: any) => {
              console.log('responseData:', responseData);

              if (sessionStorage.getItem('accessToken')) {
                this.authService.setAuthLibAttributes();
                this.permissionService.fetchPermission();
                return of(true);
              }

              this.authService.login();
              return of(false);
            }),
            catchError((error) => {
              console.error('Error fetching data from storage', error);
              this.authService.login();
              return of(false);
            }),
          );
        }

        if (this.authService.getLoggedInStatus() === 'SESSION NOT EXIST') {
          this.authService.login();
          return of(false);
        }

        console.log('validateSessionExist response:', response);
        return of(true);
      }),
      catchError((error) => {
        console.error('Error in validateSessionExist', error);
        this.authService.login();
        return of(false);
      }),
    );
  }
}
